export default __webpack_public_path__ + "static/media/chickenbiryani.12e93788.jpg";